module.exports = __webpack_public_path__ + "static/media/wipeButton.d65e13cf.png";